(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tm-buy-assurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-delivery-estimate')) {
    class TmDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const holidays = new Set((this.dataset.holidays || '').split(',').filter(Boolean));
        const parts = (value) => (value || '').split('-').map(Number);
        const [standardMin, standardMax] = parts(this.dataset.standard);
        const [expressMin, expressMax] = parts(this.dataset.express);
        if (!standardMin || !standardMax) return;

        const zoned = new Date(new Date().toLocaleString('en-US', { timeZone: 'Africa/Johannesburg' }));
        const iso = (date) =>
          `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        const isWorkingDay = (date) => date.getDay() !== 0 && date.getDay() !== 6 && !holidays.has(iso(date));
        const addWorkingDays = (from, count) => {
          const date = new Date(from);
          let added = 0;
          while (added < count) {
            date.setDate(date.getDate() + 1);
            if (isWorkingDay(date)) added += 1;
          }
          return date;
        };
        const format = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
        const range = (min, max) => {
          const start = format.format(addWorkingDays(zoned, min));
          const end = format.format(addWorkingDays(zoned, max));
          return start === end ? start : `${start} – ${end}`;
        };

        const standard = document.createElement('span');
        standard.innerHTML = `<strong>Order today:</strong> standard delivery around ${range(standardMin, standardMax)}`;
        this.replaceChildren(standard);
        if (expressMin && expressMax) {
          this.append(document.createTextNode(`, or express around ${range(expressMin, expressMax)}.`));
        } else {
          this.append(document.createTextNode('.'));
        }
        this.append(document.createTextNode(' Estimated, excluding weekends and public holidays.'));
        this.hidden = false;
      }
    }
    customElements.define('tm-delivery-estimate', TmDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
